import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "content-area" }
const _hoisted_2 = { class: "main-view-container" }
const _hoisted_3 = {
  key: 0,
  class: "no-docs-message"
}
const _hoisted_4 = {
  key: 1,
  class: "subtabs-wrapper"
}
const _hoisted_5 = {
  key: 0,
  class: "tab-title-container"
}
const _hoisted_6 = {
  key: 0,
  class: "list-view-content"
}
const _hoisted_7 = {
  key: 1,
  class: "line-view-content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_LiniiDocumenteView = _resolveComponent("LiniiDocumenteView")!
  const _component_LiniView = _resolveComponent("LiniView")!
  const _component_DxTabPanel = _resolveComponent("DxTabPanel")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["documents-layout", { 'sidebar-collapsed': !_ctx.isSidebarVisible }])
  }, [
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.allTabs.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("h2", null, "Niciun document deschis.", -1)
            ]))]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_DxTabPanel, {
                "data-source": _ctx.allTabs,
                "selected-index": _ctx.activeSubTab,
                onOptionChanged: _ctx.onSubTabChanged,
                height: "100%",
                class: "subtabs-panel",
                "scrolling-enabled": true,
                "show-nav-buttons": true
              }, {
                title: _withCtx(({ data, index }) => [
                  (data && data.title)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("span", null, _toDisplayString(data.title), 1),
                        (!data.isList)
                          ? (_openBlock(), _createBlock(_component_DxButton, {
                              key: 0,
                              icon: "close",
                              text: "",
                              "styling-mode": "text",
                              onClick: ($event: any) => (_ctx.closeSubTab(index))
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                item: _withCtx(({ data }) => [
                  (data.id === 'linii-tab')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_LiniiDocumenteView, {
                          onOpenDocument: _ctx.openDocumentDetailTab,
                          onToggleFilters: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleSidebar($event))),
                          ref: "liniiDocumenteViewRef",
                          "initial-filters": _ctx.params
                        }, null, 8, ["onOpenDocument", "initial-filters"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        (data.Document)
                          ? (_openBlock(), _createBlock(_component_LiniView, {
                              key: 0,
                              document: data.Document,
                              onToggleDetails: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isSidebarVisible = !_ctx.isSidebarVisible)),
                              onRefreshDocument: _cache[2] || (_cache[2] = ($event: any) => (_ctx.refreshDocumentData($event)))
                            }, null, 8, ["document"]))
                          : _createCommentVNode("", true)
                      ]))
                ]),
                _: 1
              }, 8, ["data-source", "selected-index", "onOptionChanged"])
            ]))
      ])
    ])
  ], 2))
}